"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tooltip = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _core = require("@material-ui/core");

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Tooltip = function Tooltip(_ref) {
  var title = _ref.title,
      children = _ref.children,
      direction = _ref.direction,
      text = _ref.text,
      custom = _ref.custom,
      color = _ref.color,
      width = _ref.width,
      referenceIconSize = _ref.referenceIconSize,
      popperIconSize = _ref.popperIconSize,
      arrow = _ref.arrow,
      breakpoint = _ref.breakpoint,
      modalContent = _ref.modalContent,
      modalClasses = _ref.modalClasses,
      openModal = _ref.openModal,
      onOpenModal = _ref.onOpenModal,
      onCloseModal = _ref.onCloseModal;
  var defaultTooltipClasses = (0, _styles.useDefaultTooltipStyles)();
  var defaultIconButtonClasses = (0, _styles.useDefaultButtonStyles)();
  var customButtonClasses = (0, _styles.useCustomButtonStyles)();
  var customTooltipClasses = (0, _styles.useCustomTooltipStyles)({
    color: color,
    width: width
  });
  var popperIconClasses = (0, _styles.usePopperIconStyles)();
  var defaultModalClasses = (0, _styles.useModalStyles)();
  var customModalClasses = modalClasses ? modalClasses() : null;
  var saraivaTheme = (0, _core.useTheme)();
  var isMobile = (0, _core.useMediaQuery)(saraivaTheme.breakpoints.down(breakpoint));

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleToggleOpen = function handleToggleOpen() {
    setOpen(!open);
  };

  var TooltipLabel = function TooltipLabel() {
    var colors = {
      primary: 'primary',
      secondary: 'secondary',
      grey: 'initial'
    };
    return /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body2",
      component: "span",
      color: custom ? colors[color] : 'initial',
      style: {
        marginRight: saraivaTheme.spacing(0.5)
      }
    }, text);
  };

  var CustomTooltipIconButton = /*#__PURE__*/_react.default.forwardRef(function CustomTooltipIconButton(props, ref) {
    var styles = color === 'grey' ? {
      style: {
        color: saraivaTheme.palette.grey[600]
      }
    } : {
      color: color
    };
    return /*#__PURE__*/_react.default.createElement(_core.IconButton, _extends({}, props, {
      ref: ref,
      classes: customButtonClasses,
      disableRipple: true
    }), text && /*#__PURE__*/_react.default.createElement(TooltipLabel, {
      text: text
    }), /*#__PURE__*/_react.default.cloneElement(children, _objectSpread({}, styles)));
  });

  var TooltipWrapper = (0, _core.withStyles)(function (theme) {
    return {
      root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 4,
        padding: theme.spacing(1, 2)
      }
    };
  })(_core.Box);
  var TooltipText = (0, _core.withStyles)(function (theme) {
    return {
      root: {
        margin: theme.spacing(0, 0, 0, 1.25)
      }
    };
  })(_core.Typography);
  var TooltipModalPaper = (0, _core.withStyles)(function (theme) {
    return {
      root: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[5],
        maxWidth: '90%',
        minWidth: 307
      }
    };
  })(_core.Paper);

  var tooltipModalBody = /*#__PURE__*/_react.default.createElement(TooltipModalPaper, null, modalContent);

  var mobileProps = function mobileProps() {
    return isMobile ? {
      onClick: custom ? onOpenModal : handleToggleOpen,
      onMouseLeave: handleClose
    } : '';
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Tooltip, _extends({
    placement: direction,
    text: text,
    arrow: arrow,
    title: custom ? /*#__PURE__*/_react.default.createElement(TooltipWrapper, null, /*#__PURE__*/_react.default.cloneElement(children, {
      fontSize: popperIconSize,
      classes: popperIconClasses
    }), /*#__PURE__*/_react.default.createElement(TooltipText, {
      component: "p",
      variant: "body1"
    }, title)) : title,
    classes: custom ? customTooltipClasses : defaultTooltipClasses,
    open: open,
    onClose: handleClose,
    onOpen: handleOpen,
    TransitionProps: {
      timeout: 0
    },
    disableHoverListener: isMobile
  }, mobileProps()), custom ? /*#__PURE__*/_react.default.createElement(CustomTooltipIconButton, {
    size: referenceIconSize
  }) : /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    classes: defaultIconButtonClasses,
    disableRipple: true
  }, text && /*#__PURE__*/_react.default.createElement(TooltipLabel, {
    text: text
  }), children)), /*#__PURE__*/_react.default.createElement(_core.Modal, {
    open: openModal,
    onClose: onCloseModal,
    className: "".concat(defaultModalClasses.modal, " ").concat(customModalClasses ? customModalClasses.modal : '')
  }, tooltipModalBody));
};

exports.Tooltip = Tooltip;
Tooltip.propTypes = {
  /**
   * O texto da Tooltip
   */
  title: _propTypes.default.string.isRequired,

  /**
   * Elemento de referência da Tooltip
   */
  children: _propTypes.default.node,

  /**
   * Define o posicionamento da Tooltip de acordo com o espaço disponível
   */
  direction: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Texto opcional para ser usado como label, ao lado do elemento de referência
   */
  text: _propTypes.default.string,

  /**
   * Habilita/Desabilita a seta de indicação do Tooltip
   */
  arrow: _propTypes.default.bool,

  /**
   * Token do breakpoint que corresponde a quebra do desktop para o mobile.
   */
  breakpoint: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * Define se a Tooltip será simples ou Customizada
   */
  custom: _propTypes.default.bool,

  /**
   * Cor de destaque do ícone e da Tooltip Customizada
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'grey']),

  /**
   * Tamanho máximo do container da Tooltip Customizada
   */
  width: _propTypes.default.number,

  /**
   * Tamanho do icone de referência da Tooltip Customizada
   */
  referenceIconSize: _propTypes.default.oneOf(['small', 'medium']),

  /**
   * Tamanho do icone exibido na Tooltip Customizada
   */
  popperIconSize: _propTypes.default.oneOf(['small', 'medium']),

  /**
   * Conteúdo interno do modal na Tooltip Customizada mobile
   */
  modalContent: _propTypes.default.node,

  /**
   * Classes para customizar do modal na Tooltip Customizada mobile
   */
  modalClasses: _propTypes.default.func,

  /**
   * Estado que seta abertura/fechamento do modal na Tooltip Customizada mobile
   */
  openModal: _propTypes.default.bool,

  /**
   * Função responsável por fechar o modal na Tooltip Customizada mobile
   */
  onCloseModal: _propTypes.default.func,

  /**
   * Função responsável por abrir o modal na Tooltip Customizada mobile
   */
  onOpenModal: _propTypes.default.func
};
Tooltip.defaultProps = {
  children: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
  direction: 'right',
  text: '',
  custom: false,
  color: 'primary',
  width: 444,
  referenceIconSize: 'small',
  popperIconSize: 'small',
  arrow: false,
  breakpoint: 'sm',
  modalContent: null,
  modalClasses: null,
  openModal: false,
  onCloseModal: function onCloseModal() {
    return null;
  },
  onOpenModal: function onOpenModal() {
    return null;
  }
};
var _default = Tooltip;
exports.default = _default;